import { defineMessages } from 'react-intl'

const scope = `procurify.platform.banking.features.create-external-payment-method.views.ExternalPaymentMethodForm`

export default defineMessages({
  fieldRequiredMessage: {
    id: `${scope}.fieldRequiredMessage`,
    defaultMessage: 'This field is required',
  },
  nameFieldLabel: {
    id: `${scope}.nameFieldLabel`,
    defaultMessage: 'Payment method name',
  },
  currencyFieldLabel: {
    id: `${scope}.currencyFieldLabel`,
    defaultMessage: 'Currency',
  },
  descriptionFieldLabel: {
    id: `${scope}.descriptionFieldLabel`,
    defaultMessage: 'Description',
  },
  warningAlertText: {
    id: `${scope}.warningAlertText`,
    defaultMessage:
      "External payment methods are used for tracking and approval purposes, and can't be used to make payments within Procurify.",
  },
  submitButtonLabel: {
    id: `${scope}.submitButtonLabel`,
    defaultMessage: 'Add payment method',
  },
  backButton: {
    id: `${scope}.backButton`,
    defaultMessage: 'Back',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
})
